export default {
  // 动态
  Brand: '品牌管理',
};
